import React, { Component } from 'react';

class Scroll extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  handleClick() {
    this.props.handleScrollClick()
  }

  render() {
    return (
        <div className="scroll" onClick={this.handleClick.bind(this)}>
            <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174.19 417.48"><defs></defs><title>controls_0-43-512</title><path className="cls-1" fill={this.props.color} d="M683,355.63q0,32,0,64c0,43.81-34.17,78.05-77.92,78.1-13.13,0-26.31.77-39.23-2.81-33.13-9.19-56.66-39.31-56.82-73.74q-0.32-66.24,0-132.47c0.23-41,34.18-75.13,75.13-75.67,14.11-.19,28.29-1.12,42.22,2.73,32.64,9,56.23,39.08,56.55,72.88,0.21,22.33,0,44.66,0,67h0Zm-159.14-.06h0c0,21.82-.14,43.65,0,65.47,0.22,28.12,18.38,52.34,45.84,58.75,11.62,2.71,24.11,2.34,36.2,2.28,34.19-.18,61.17-26.37,61.6-60.54,0.55-44,.48-88,0-131.93-0.3-30.5-21.41-55.17-51.21-60.15-9.43-1.58-19.26-1.18-28.9-1.08-37.47.37-63.53,26.78-63.62,64.24C523.84,313.6,523.88,334.59,523.88,355.58Z" transform="translate(-508.87 -212.8)"/><path className="cls-1" fill={this.props.color} d="M588.22,602.85c0-11.61,0-23.4,0-35.2,0-9.83,0-19.65,0-29.48,0-6.46,2.83-10.18,7.67-10.27s7.84,3.64,7.86,10.06c0,19.32,0,38.64,0,58,0,2.14,0,4.28,0,7.31a43,43,0,0,0,3.48-2.72C613.51,594.3,619.7,588,626,581.82c4-3.91,8.79-4.29,12-1.17s3,7.72-1.12,11.81q-17.09,17.18-34.27,34.27c-4.8,4.77-8.44,4.71-13.24-.07q-17-16.93-33.93-33.91c-4.29-4.29-4.74-8.83-1.31-12.19s7.63-2.85,12.18,1.53C573.44,589,580.74,595.79,588.22,602.85Z" transform="translate(-508.87 -212.8)"/><path className="cls-1" fill={this.props.color} d="M603.76,306.49c0,8.5.06,17,0,25.5-0.05,5.86-3.33,9.65-8,9.49-4.48-.15-7.5-3.8-7.52-9.43q-0.09-25.75,0-51.49c0-5.55,3.19-9.14,7.76-9.15s7.68,3.35,7.75,9.09c0.1,8.66,0,17.33,0,26h0Z" transform="translate(-508.87 -212.8)"/></svg>
        </div>
    );
  }
}

export default Scroll;
